import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlindsClosedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blinds_closed"}/>
}
